import { useEffect } from 'react';
import { useShopifyConnection } from '../hooks/useShopifyConnection';

/**
 * Component that handles Shopify connection using session tokens.
 * This should be rendered once the user is authenticated.
 */
export const ShopifyConnectionHandler: React.FC = () => {
  const { isConnecting, isConnected, error } = useShopifyConnection();

  useEffect(() => {
    if (isConnecting) {
      console.log('[Shopify Connection Handler] Connecting to Shopify...');
    }
    if (isConnected) {
      console.log('[Shopify Connection Handler] Successfully connected to Shopify');
    }
    if (error) {
      console.error('[Shopify Connection Handler] Connection error:', error);
    }
  }, [isConnecting, isConnected, error]);

  // This component doesn't render anything visible
  return null;
};

